import { DateTime } from "luxon";
export function metarsFromTransferable({ metars }) {
    const parsedMetars = metars.map((m) => ({
        icao_code: m.icao_code,
        metar_report: m.metar_report,
        issue_time: DateTime.fromISO(m.issue_time),
    }));
    return {
        metars: parsedMetars
    };
}
//# sourceMappingURL=MetarsResponse.js.map